import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./i18n.js";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import config from "./config";
import { store } from "./store";
import mapboxgl from "mapbox-gl";
import { ThemeConfig } from "@assist/theme";
import EventEmitter from "events";
import "mapbox-gl/dist/mapbox-gl.css";
import { DeviceProvider } from "./providers/DeviceProvider";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import "moment/locale/nb";
import { NotificationContextProvider } from "./providers/NotificationProvider.jsx";
import { LicenseInfo } from "@mui/x-license-pro";
import { SnackbarProvider } from "notistack";
import moment from "moment/moment";
import { HelmetProvider, Helmet } from "react-helmet-async";
import { calcUIDimensions } from "./common/helpers.js";
import ErrorBoundary from "./components/common/display/ErrorBoundary.jsx";
import ExceptionPage from "./components/pages/error/ExceptionPage.jsx";

calcUIDimensions();
setTimeout(calcUIDimensions, 50);

// Locale fromNow
moment.updateLocale("nb", {
  relativeTime: {
    future: "om %s",
    past: "%s siden",
    s: "noen sek",
    ss: "%d sek",
    m: "1 min",
    mm: "%d min",
    h: "1t",
    hh: "%dt",
    d: "1d",
    dd: "%dd",
    M: "1mnd",
    MM: "%dmnd",
    y: "1år",
    yy: "%dår"
  }
});


// print version
LicenseInfo.setLicenseKey("4804d304c7e9cf09212d4079b698a244Tz0xMjY4MDQsRT0xODA0ODA5NTk5MDAwLFM9cHJvLExNPWFubnVhbCxQVj1RMy0yMDI0LEtWPTI=");

// Set mapbox access token
mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_TOKEN || "pk.eyJ1IjoibGVpZmVtYmVybHkiLCJhIjoiY21ldmw1YjFxMDFidjJsczE3ZTU3MnhhdSJ9.v1cS-7Pl5eTfLwNAwKpLVg";

// Event emitter for theme changes
const themeEventListener = new EventEmitter();
const themeMode = "light";

// React entry point
const root = ReactDOM.createRoot(document.getElementById("root"));


root.render(
  <React.StrictMode>
    <Provider store={store}>
      <HelmetProvider>
        <BrowserRouter basename={config.basename}>
          <DeviceProvider>
            <ThemeConfig mode={themeMode} events={themeEventListener}>
              <SnackbarProvider autoHideDuration={3500} disableWindowBlurListener>
                <NotificationContextProvider>
                  <LocalizationProvider dateAdapter={AdapterMoment}>
                    <Helmet>
                      <title>Assist Forms</title>
                    </Helmet>
                    <ErrorBoundary
                      fallback={<ExceptionPage />}
                    >
                      <App />
                    </ErrorBoundary>
                  </LocalizationProvider>
                </NotificationContextProvider>
              </SnackbarProvider>
            </ThemeConfig>
          </DeviceProvider>
        </BrowserRouter>
      </HelmetProvider>
    </Provider>
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

